import type { FC, RefObject } from "react";
import type { EmailSearchInput } from "../../../../../hooks/useEmailsRestApi";
import type { EmailWithStatus } from "../..";
import { HREmailsCardsUI } from "../HREmailsCards";
import { MatterEmailsCardsUI } from "../MatterEmailsCards";

export type EmailsCardsUIProps = {
  isMatter: boolean;
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  onToggleFavoriteEmail: (emailId: string, favorite: boolean) => void;
  currentSearchInput: EmailSearchInput;
  scrollCardRef: RefObject<HTMLDivElement>;
  scrollCardId: string | null;
};

export const EmailsCardsUI: FC<EmailsCardsUIProps> = ({
  isMatter,
  emails,
  onSelectEmail,
  onToggleFavoriteEmail,
  currentSearchInput,
  scrollCardRef,
  scrollCardId,
}) => {
  return isMatter ? (
    <MatterEmailsCardsUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      onToggleFavoriteEmail={onToggleFavoriteEmail}
      currentSearchInput={currentSearchInput}
      scrollCardRef={scrollCardRef}
      scrollCardId={scrollCardId}
    />
  ) : (
    <HREmailsCardsUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      onToggleFavoriteEmail={onToggleFavoriteEmail}
      currentSearchInput={currentSearchInput}
      scrollCardRef={scrollCardRef}
      scrollCardId={scrollCardId}
    />
  );
};
